module.exports = "<small *ngIf=\"errorMessage !== undefined\" class=\"errorMessage\" class=\"text-danger\">\n  {{ errorMessage }}\n</small>\n"